import { FunctionComponent, useMemo } from 'react'
import { LatLngExpression } from 'leaflet'
import { Marker } from 'react-leaflet'
import { MapTask } from './map-types'

import L from 'leaflet'

/**
 * Properties type for TaskMarker
 */
export type TaskMarkerProps = {
  task: LatLngExpression | MapTask
  styles?: string
  num?: number
  onTaskClick?: (task?: MapTask | LatLngExpression) => void
  onOpenPopup?: (task: MapTask | LatLngExpression) => void
  onClosePopup?: () => void
  copy?: (text: string) => string
}

export const TaskMarker: FunctionComponent<TaskMarkerProps> = ({
  task,
  styles = '',
  num,
  onTaskClick = () => {},
  onOpenPopup = () => {},
  onClosePopup = () => {}
}) => {
  const circleStyles = styles || 'border: 2px solid #1890FF; color: #1890FF;'
  const number = `<div style="${circleStyles}" class='circle-id'><span>${num ?? ''}</span></div>`
  const icon = L.divIcon({
    className: 'custom-task-icon',
    html: `<div class='marker-pin'>${number}</div>`,
    iconSize: [30, 42],
    iconAnchor: [15, 42]
  })

  const eventHandlers = useMemo(
    () => ({
      popupopen: () => {
        onOpenPopup(task)
      },
      popupclose: () => onClosePopup(),
      click: () => {
        onTaskClick(task)
      }
    }),
    []
  )

  if (Array.isArray(task)) {
    return <Marker position={task} icon={icon} eventHandlers={eventHandlers} />
  } else {
    const {
      destination: { latitude, longitude }
    } = task as MapTask
    return <Marker position={[latitude, longitude]} icon={icon} eventHandlers={eventHandlers} />
  }
}
